export default __webpack_public_path__ + "static/media/event-pool.2164a769.png";